import { useState } from "react"

export const useModalDiasFestivos = (initialValue = false) => {
  const [isOpenDiasFestivos, setIsOpen] = useState(initialValue);

  const openModalDiasFestivos = () => setIsOpen(true);
  const closeModalDiasFestivos = () => setIsOpen(false);

  return [isOpenDiasFestivos, openModalDiasFestivos, closeModalDiasFestivos]
}